import { getDataFromForm } from '../../utils/misc';
import SelectorEngine from '../../utils/dom/selector-engine';
import Request from '../../utils/request';
import Modal from '../../components/Modal';
import { startLoadingAnimation, stopLoadingAnimation } from '../../utils/dom/loading';
import Manipulator from '../../utils/dom/manipulator';
import AddressSearch from '../../components/AddressSearch';

class EditAddress {
	constructor() {
		this._container = SelectorEngine.findOne('.js-edit-coach-details-address');

		if (this._container) {
			this.init();
		}
	}

	init() {
		this._exitModal = new Modal(SelectorEngine.findOne('#coach-details-address-exit', this._container), {});
		this._form = SelectorEngine.findOne('#lta-coach-details__edit-address', this._container);
		this._cancelCta = SelectorEngine.findOne('.lta-coach-details__edit-address-back', this._container);
		this._cancelCta.addEventListener('click', () => this._exitModal.show());
		this._errorContainer = SelectorEngine.findOne('.lta-coach-details__edit-address-error', this._container);
		this._errorContainerCta = SelectorEngine.findOne(
			'.lta-coach-details__edit-address-error-btn',
			this._errorContainer
		);

		this._errorContainerCta.addEventListener('click', () => this._errorContainer.classList.add('u-hidden'));

		const popupCancel = SelectorEngine.findOne('.lta-coach-details__edit-address-continue', this._container);
		popupCancel.addEventListener('click', () => this._exitModal.hide());

		const popupContinue = SelectorEngine.findOne('.lta-coach-details__edit-address-exit', this._container);
		popupContinue.addEventListener('click', (event) => this.backToUrl(event));

		this._saveCta = SelectorEngine.findOne('.lta-coach-details__edit-address-save', this._container);
		this._saveCta.addEventListener('click', () => this.submitForm(this._form));

		const addressForm = SelectorEngine.findOne('.js-retrive-address', this._container);
		this._addressSearch = AddressSearch.getOrCreateInstance(addressForm);
	}

	backToUrl(event, redirectUrl) {
		const rootUrl = window.location.origin;
		const url = redirectUrl || event.currentTarget.dataset.target;
		window.location.href = `${rootUrl}${url}`;
	}

	async submitForm() {

		// Validate address before saving
		const isValidAddress = await this._addressSearch.validate();
		if(isValidAddress !== 'Valid') {
			return;
		}

		startLoadingAnimation(true);
		const addressForm = SelectorEngine.findOne('.js-coach-details-edit-address', this._container);
		const dataObject = getDataFromForm(addressForm); 
		const payload = {
			updateCoachDetailsRequest: {
				myAddress: {
					mailingStreet: dataObject.street,
					mailingCity: dataObject.city,
					county: dataObject?.state,
					postCode: dataObject.postCode
				}
			}
		};

		try {
			const url = `/api/coachdetails/update`;
			const responseData = await Request.post(url, payload);
			const { success } = responseData;
			if (success) {
				const redirectUrl = Manipulator.getDataAttribute(this._form, 'redirect-url');
				window.location.href = redirectUrl;
			} else {
				this._errorContainer.classList.remove('u-hidden');
			}
		} catch {
			this._errorContainer.classList.remove('u-hidden');
		} finally {
			stopLoadingAnimation();
		}
	}
}

const globalEditAddress = new EditAddress();

export default globalEditAddress;
